<div class="container spaceContainer">
  <div class="divRight" style="justify-content: space-between;">
    <button tabindex="1" arial-label="enforcar contenido principal" mat-button (click)="enfocar()" (keyup.enter)="enfocar()">Ir a Contenido Principal</button>
    <button tabindex="1" class="circulo" aria-label="Iniciales candidato" role="text" matTooltip="{{usuario.nombre}} {{usuario.apellido}}">{{inciales}}</button>
    <a class="styleText" tabindex="1" aria-label="Rol candidato" *ngIf="log =='cand'">Candidato</a>
    <a class="styleText" tabindex="1" aria-label="Rol administrador" *ngIf="log =='admin'">Administrador MVO</a>
    <span tabindex="1" class="styleIcon" type="button" (click)="salir()" id="idSalida" aria-label="Cerrar sesión" matTooltip="Cerrar sesión">
      <i class="fas fa-sign-out-alt fa-2x"></i>
    </span>
  </div>
</div>
<div class="container spaceContainer">
  <div class="styleHeaderLogos">
    <div matTooltip="Logo Sena" aria-label="Logo Sena">
      <img tabindex="0" class="logoSena1" alt="Logo SENA" src="../../../assets/img/home/header/logoSenaTransparente.png">
    </div>
    <td></td>
    <div style="margin-left: auto" matTooltip="Logo ministerio del trabajo">
      <a (click)="mostrarAlerta('Ministerio del Trabajo','https://www.mintrabajo.gov.co','_blank')" class="cursor-pointer">
        <img tabindex="0" class="logoMintic1" alt="Logo ministerio del trabajo"
             src="../../../assets/img/home/header/Logo-MintrabajoTransparente.png">
      </a>
    </div>
  </div>
</div>
<div id="sidebar-accordion" class="accordion sticky">
  <div class="list-group" matTooltip="Menú de accesibilidad">
    <a tabindex="6" href="#dashboard-items" data-toggle="collapse" aria-expanded="false" class="list-group-item list-group-item-action bg-light text-grey" aria-label="Menú de accesibilidad">
      <i class="fas fa-cog fa-spin"></i>
    </a>
    <div id="dashboard-items" class="collapse" data-parent="#sidebar-accordion">
      <a tabindex="0" class="list-group-item list-group-item-action bg-light text-grey pl-5" (click)="aumentar()" (keyup.enter)="aumentar()" role="button" aria-label="Aumentar tamaño letra">A+</a>
      <a tabindex="0" class="list-group-item list-group-item-action bg-light text-grey pl-5" (click)="normal()" (keyup.enter)="normal()" role="button" aria-label="Restablecer vista">A</a>
      <a tabindex="0" class="list-group-item list-group-item-action bg-light text-grey pl-5" (click)="disminuir()" (keyup.enter)="disminuir()" role="button" aria-label="Disminuir tamaño letra">A-</a>
      <a tabindex="0" class="list-group-item list-group-item-action bg-light text-grey pl-5 material-icons" (click)="cambiar()" (keyup.enter)="cambiar()" role="button" aria-label="Cambiar a grises">
        <i class="fas fa-adjust"></i>
      </a>
      <a tabindex="0" class="list-group-item list-group-item-action bg-light text-grey pl-5 material-icons" aria-label="opción no disponible"><i class="fas fa-moon disabledOption"></i></a>
    </div>
  </div>
</div>
